module.exports = __webpack_public_path__ + "stylesheets/landing-new_e07c1a85372ce9833323a8c62f96997c.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing/landing-new.less
// module id = 3Sex
// module chunks = 118